import { LoadOpenIdXHR } from '@services/LoadOpenIdXHR';
import { CrossFrameUtils } from '@utils/CrossFrameUtils';

export class SentryService {
    public static async makeSentryCall(request, client, extraOptions?): Promise<any> {
        extraOptions = extraOptions || {};
        extraOptions.sensitive = !!extraOptions.sensitive;
        console.debug(CrossFrameUtils.getDataForLoggingEvent(extraOptions.sensitive, request));
        try {
            await LoadOpenIdXHR.load();
            if (!client.hasOwnProperty('post')) {
                return Promise.resolve(client(request));
            }
            try {
                const response = await client.post(request);
                return response;
            } catch (errorResponse) {
                return Promise.reject(errorResponse);
            }
        } catch (error) {
            return error;
        }
    }
}
